import { API } from 'utils';
import { IParams } from 'http-requests/types';
import { GW_SERVICES_PREFIXES } from 'constants/gateway';

const { C300 } = GW_SERVICES_PREFIXES;

export const GetWeather = (params: IParams) =>
  API.get(
    `/${C300}/automation/weather_average/`,
    undefined,
    params
  );
